"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconInstagram = function IconInstagram(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M21.94 7.88a7.6 7.6 0 0 0-.46-2.43 4.85 4.85 0 0 0-1.16-1.77 4.85 4.85 0 0 0-1.77-1.16 7.6 7.6 0 0 0-2.43-.46C15.06 2 14.72 2 12 2s-3.06 0-4.12.06a7.6 7.6 0 0 0-2.43.46 4.85 4.85 0 0 0-1.77 1.16 4.85 4.85 0 0 0-1.16 1.77 7.6 7.6 0 0 0-.46 2.43C2 8.94 2 9.28 2 12s0 3.06.06 4.12c.02.83.175 1.65.46 2.43a4.85 4.85 0 0 0 1.16 1.77 4.7 4.7 0 0 0 1.77 1.15 7.3 7.3 0 0 0 2.43.47C8.94 22 9.28 22 12 22s3.06 0 4.12-.06a7.3 7.3 0 0 0 2.43-.47 4.7 4.7 0 0 0 1.77-1.15 4.85 4.85 0 0 0 1.16-1.77c.285-.78.44-1.6.46-2.43 0-1.06.06-1.4.06-4.12s0-3.06-.06-4.12M20.14 16a5.6 5.6 0 0 1-.34 1.86 3.33 3.33 0 0 1-1.9 1.9 5.6 5.6 0 0 1-1.86.34c-1 .05-1.37.06-4 .06s-3 0-4-.06a5.6 5.6 0 0 1-1.94-.3 3.33 3.33 0 0 1-1.9-1.9 5.6 5.6 0 0 1-.34-1.9c0-1-.06-1.37-.06-4s0-3 .06-4a5.6 5.6 0 0 1 .34-1.9 3.33 3.33 0 0 1 1.9-1.9A5.6 5.6 0 0 1 8 3.86c1 0 1.37-.06 4-.06s3 0 4 .06a5.6 5.6 0 0 1 1.86.34 3.33 3.33 0 0 1 1.9 1.9 5.6 5.6 0 0 1 .38 1.9c.05 1 .06 1.37.06 4s-.01 3-.06 4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M12 6.86a5.14 5.14 0 1 0 0 10.28 5.14 5.14 0 0 0 0-10.28m0 8.47a3.33 3.33 0 1 1 0-6.66 3.33 3.33 0 0 1 0 6.66M17.34 5.46a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4"
  })));
};

export { IconInstagram, IconInstagram as default };
